"use strict";

import Turbolinks from "turbolinks";

export default function () {
    const verifyExist = document.querySelector(".js-podcasts-holder");

    if (verifyExist) {
        Turbolinks.start();
    }
}
